import { CONST } from "../../../CONST";
import Distraction, { DistractionConfig, DistractionState} from "../Distraction";

const CONFIG = {
    ballBounds: {
        x: {from: -62, to: 77},
        y: {from: -47, to: 45},
    },
    ballSpeed: {
        x: {from: 50, to: 70},
        y: {from: -50, to: 50},
        yChangeMax: 100,
    },
    paddleTrigger: {
        left: -10,
        right: 25,
    }
}

export default class TvDistraction extends Distraction {

    private container : Phaser.GameObjects.Container;
    private tvBackground : Phaser.GameObjects.Image;

    private pongContainer : Phaser.GameObjects.Container;
    private scoreLeft: Phaser.GameObjects.Image;
    private scoreRight: Phaser.GameObjects.Image;
    private paddleLeft: Phaser.GameObjects.Image;
    private paddleRight: Phaser.GameObjects.Image;
    private ball: Phaser.GameObjects.Image;

    private ballSpeed = {x: 90, y: 30};

    constructor(scene: Phaser.Scene, config: DistractionConfig){
        super(scene, config);

        this.container = scene.add.container(config.x, config.y).setDepth(config.depth);

        this.tvBackground = scene.add.image(0, 0, CONST.DISTRACTION.TV_SCREEN_DARK);
        this.tvBackground.setInteractive({useHandCursor: true, pixelPerfect: true, alphaTolerance: 1});
        this.tvBackground.on("pointerup", () => {
            this.handleClick();
        });

        this.pongContainer = scene.add.container(0 , 0);
        this.scoreLeft = scene.add.image(-5, -37, CONST.DISTRACTION.TV_TEXT_0);
        this.scoreRight = scene.add.image(20, -37, CONST.DISTRACTION.TV_TEXT_0);
        this.paddleLeft = scene.add.image(-65, -3, CONST.DISTRACTION.TV_PADDLE);
        this.paddleRight = scene.add.image(80, -3, CONST.DISTRACTION.TV_PADDLE);
        this.ball = scene.add.image(0, 0, CONST.DISTRACTION.TV_BALL).setScale(1.5);

        this.pongContainer.add([this.scoreLeft, this.scoreRight, this.paddleLeft, this.paddleRight, this.ball]);
        this.pongContainer.setVisible(false);

        this.container.add([this.tvBackground, this.pongContainer]);
        this.init();

        this.scene.events.on('update', this.update, this);
    }

    update(time: number, delta: number){
        this.updateBallPosition(delta);
        this.updatePaddlePosition(delta);
    }
    
    updateBallPosition(delta: number){
        this.ball.setPosition(this.ball.x + this.ballSpeed.x*delta/1000, this.ball.y + this.ballSpeed.y*delta/1000);
        
        //paddle hit
        if (this.ball.x > CONFIG.ballBounds.x.to || this.ball.x < CONFIG.ballBounds.x.from){
            
            if (!this.canActivate()){//any state except deactivated
                this.scene.sound.play(CONST.AUDIO.PING_2, {volume: 2});
            }

            this.ballSpeed.x = this.ballSpeed.x * -1;

            if (this.ball.x > CONFIG.ballBounds.x.to){
                this.ball.x = CONFIG.ballBounds.x.to;
            } else {
                this.ball.x = CONFIG.ballBounds.x.from;
            }

            //change Yspeed
            let ySpeedChange = Phaser.Math.Between(-CONFIG.ballSpeed.yChangeMax, CONFIG.ballSpeed.yChangeMax);
            this.ballSpeed.y = Phaser.Math.Clamp(this.ballSpeed.y + ySpeedChange, CONFIG.ballSpeed.y.from, CONFIG.ballSpeed.y.to);
        }

        //wall hit
        if (this.ball.y > CONFIG.ballBounds.y.to || this.ball.y < CONFIG.ballBounds.y.from){
            if (!this.canActivate()){
                this.scene.sound.play(CONST.AUDIO.PING_1, {volume: 2});
            }
            this.ballSpeed.y = this.ballSpeed.y * -1;
        }
    }

    updatePaddlePosition(delta: number){
        //move left paddle
        if (this.ball.x < CONFIG.paddleTrigger.left){
            this.paddleLeft.y = Phaser.Math.Interpolation.SmoothStep((this.ball.x -this.paddleLeft.x)/(CONFIG.paddleTrigger.left - this.paddleLeft.x), this.ball.y, this.paddleLeft.y);
        }

        //move right paddle
        if (this.ball.x > CONFIG.paddleTrigger.right){
            this.paddleRight.y = Phaser.Math.Interpolation.SmoothStep((this.ball.x -this.paddleRight.x)/(CONFIG.paddleTrigger.right - this.paddleRight.x), this.ball.y, this.paddleRight.y);
        }
    }

    private handleClick(){
        this.deactivate();
    }

    onDeactivated(): void {
        this.tvBackground.clearTint();
    }

    onStarting(): void {
        this.scene.sound.play(CONST.AUDIO.TV_ON, {volume: 2});


        this.pongContainer.setVisible(true);
        this.tvBackground.setTexture(CONST.DISTRACTION.TV_SCREEN_LIGHT);

        this.scoreLeft.setTexture(this.getRandomScoreText());
        this.scoreRight.setTexture(this.getRandomScoreText());

        setTimeout(() => {
            this.changeState(DistractionState.Active);
        }, 500);

    }

    getRandomScoreText(){
       return Phaser.Utils.Array.GetRandom([CONST.DISTRACTION.TV_TEXT_0, 
        CONST.DISTRACTION.TV_TEXT_1, 
        CONST.DISTRACTION.TV_TEXT_2, 
        CONST.DISTRACTION.TV_TEXT_3,
         CONST.DISTRACTION.TV_TEXT_4]);
    }

    onActivated(): void {
    }

    onEnding(): void {
        this.scene.sound.play(CONST.AUDIO.TV_ON, {volume: 2});
        this.pongContainer.setVisible(false);
        this.tvBackground.setTexture(CONST.DISTRACTION.TV_SCREEN_DARK);

        setTimeout(() => {
            this.changeState(DistractionState.Deactivated);
        }, 500);
    }

    onGameLost(): void {
        this.tvBackground.disableInteractive();
    }
}